import type { JSX } from 'react';
import { useProcessActivityEditContext } from '@frontend/utils';
import { BooleanRadioGroupFormGroup, TextAreaFormGroup } from './processActivityFormGroupFields';

interface IYesNoWithConditionalTextAreaFormGroupProps {
    fieldKey: string;
    fieldValue: boolean | null;
    isClearable?: boolean;
    isRequired?: boolean;
    label: string;
    textAreaFieldKey: string;
    textAreaLabel?: string;
    textAreaPlaceholder?: string;
    toolTipText?: string;
}

export function YesNoWithConditionalTextAreaFormGroup(props: IYesNoWithConditionalTextAreaFormGroupProps): JSX.Element {
    const { onChange } = useProcessActivityEditContext();

    return (
        <>
            <BooleanRadioGroupFormGroup
                fieldKey={props.fieldKey}
                isClearable={Boolean(props.isClearable)}
                isRequired={Boolean(props.isRequired)}
                label={props.label}
                onChange={handleChange}
                tooltipText={props.toolTipText}
                type="radio"
            />
            {props.fieldValue && (
                <TextAreaFormGroup
                    fieldKey={props.textAreaFieldKey}
                    isRequired={Boolean(props.isRequired)}
                    label={`${props.textAreaLabel ?? props.label.toLowerCase()}`}
                    placeholder={props.textAreaPlaceholder}
                />
            )}
        </>
    );

    async function handleChange(value: boolean | null): Promise<void> {
        return onChange(
            {
                [props.fieldKey]: value,
                [props.textAreaFieldKey]: null,
            },
            props.fieldKey
        );
    }
}
